module.exports = __webpack_public_path__ + "media/images/Modal-60013c8b83a2eb8aa89fabd13fadc1fe.svg";